import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-faceback",
  "use": "icon-faceback-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-faceback\">\n  <path d=\"M870.534 64.223H153.022c-49.329 0-89.241 40.36-89.241 89.689l-0.448 807.201 179.378-179.378h627.823c49.329 0 89.689-40.36 89.689-89.689V153.912c0-49.329-40.36-89.689-89.689-89.689z m-313.911 403.6h-89.689V198.757h89.689v269.066z m0 179.378h-89.689v-89.689h89.689v89.689z\" p-id=\"2802\" fill=\"#8a8a8a\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol